import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CenterContent from "../Components/CenterContent/CenterContent";
import InstrumentsWrrapper from "../Components/InstrumentsWrrapper/InstrumentsWrrapper";
import { observer } from "mobx-react-lite"
import AcceptRight from "../block/Accept/AcceptRight";
import { SelectType } from "../store/models";
import { AcceptCustomer } from './Accept/AcceptCustomer';
import { AcceptStudent } from './Accept/AcceptStudent';
import { direction } from './../store/direction';
import { AcceptRightContainer } from './Accept/AcceptRightContainer';
import AcceptLeft from "../block/Accept/AcceptLeft";

export const AccepterContainer = observer(function() {
  const { t } = useTranslation();

    const [ studentOrTeacher , setStudentOrTeacher ] = useState<SelectType>({
        value: 1,
        label: "Сотрудники"
    },)

    

  return (
    <CenterContent>
        <InstrumentsWrrapper
            leftHead={t("st:instrument.titles.accept")}
            rightHead={t("st:instrument.titles.settings")}
            leftChilds={<AcceptRight onChange={ setStudentOrTeacher } value={studentOrTeacher} />}
            rightChilds={<AcceptLeft onChange={ setStudentOrTeacher } value={studentOrTeacher} />}
            leftIcon={<></>}
            rightIcon = {<></>}
        />
      {
        direction.leftOrRight == "left"?
        studentOrTeacher.value == 1 ? <AcceptCustomer /> : < AcceptStudent />
        :
        <AcceptRightContainer ts = { studentOrTeacher.value } />
      }
    </CenterContent>
  );
})